exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading {\r\n    margin-left: 48%;\r\n    margin-top: 20%;\r\n  }\r\n\r\n  .loadingDiv {\r\n    position: fixed; \r\n    z-index: 999;\r\n    width: 100%;\r\n    height: 100%;\r\n\r\n  }\r\n\r\n  @media only screen and (max-width: 768px) {\r\n  .loading {\r\n    margin-left: 48%;\r\n    margin-top: 50%;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main